<app-wizard-modal (stepChange)="onStepChange($event)"
                  (stepErrosChange)="onStepErrosChange()"
                  [isLoading]="isLoading"
                  (cancel)="close()"
                  (submit)="createTicket()">
    <app-wizard-title>{{ 'admin.tickets.create-modal.title' | translate }}</app-wizard-title>
    <app-wizard-step [canContinue]="canContinueStep1()">
        <ng-template #title> {{ 'admin.tickets.create-modal.sections.ticketDetails' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <form class="picklist-form" [formGroup]="ticketForm">
                <div class="row">
                    <div class="col s12">
                        <app-display-label *ngIf="!multipleTools"
                                           label="{{'admin.tickets.create-modal.selectedTool' | translate}}"
                                           [valueStyle]="{'max-width': '100%'}"
                                           [value]="issue?.tools[0]?.identifierName">
                        </app-display-label>
                        <div *ngIf="multipleTools">
                            <div class="row"></div>
                            <app-tool-scan-tree
                                labelText="{{'admin.tickets.create-modal.selectedTools'| translate}}"
                                [items]="issue.tools">
                            </app-tool-scan-tree>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col s12">
                        <app-textarea formControlName="description"
                                   [formControl]="ticketForm.controls['description']"
                                   [showErrors]="showValidations"
                                   placeholder="{{'admin.tickets.create-modal.description-input.placeholder' | translate }}"
                                   label="{{'admin.tickets.create-modal.description-input.label' | translate}}">
                        </app-textarea>
                    </div>
                </div>
                <div class="row" *ngIf="mandatoryOperations && mandatoryOperations.length">
                    <div class="col s12">
                        <p>{{ 'admin.tickets.create-modal.mandatoryOperations' | translate }}</p>
                        <li *ngFor="let operation of mandatoryOperations">{{ operation.name }}</li>
                    </div>
                </div>
                <div class="row">
                    <div class="col s12">
                        <app-picklist
                            [source]="availableOperations"
                            [(target)]="ticketForm.value.operationTypes"
                            [formControl]="ticketForm.controls.operationTypes"
                            [showValidations]="showValidations"
                            sourceHeader="{{'admin.tickets.create-modal.operation-types-input.leftHeader' | translate}}"
                            targetHeader="{{'admin.tickets.create-modal.operation-types-input.rightHeader' | translate}}"
                            infoLabel="{{'admin.tickets.create-modal.alert.message' | translate}}"></app-picklist>

                    </div>
                </div>
            </form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step *ngIf="toolsHaveMaintenancePlan()" [canContinue]="operationsWithRecurrencesForm.valid">
        <ng-template #title>{{ 'admin.tickets.create-modal.sections.ticketRecurrences' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <div *ngIf="isLoading" class="loading">
                <app-loading-spinner></app-loading-spinner>
            </div>
            <form *ngIf="!isLoading" [formGroup]="operationsWithRecurrencesForm">
                <div class="button-container">
                    <app-button (click)="openRevisionModal()">
                        {{ 'admin.tickets.create-modal.revisionInfo.modal-button' | translate }}
                    </app-button>
                </div>

                <app-activities-form [formControl]="operationsWithRecurrencesForm.controls['selectedRecurrencesItems']"
                                     [items]="selectedRecurrencesItems"
                                     [activities]="operationsWithRecurrences">
                </app-activities-form>
            </form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step [canSave]="!isLoading">
        <ng-template #title>{{ 'admin.tickets.create-modal.sections.ticketOverview' | translate }}</ng-template>
        <ng-template #content let-step="step">
            <div *ngIf="toolsHaveMaintenancePlan() else infoMessage">
                <div style="margin-bottom: 1rem"></div>
                <app-ticket-overview [overviewItems]="overviewItems"
                                     [description]="issue.description">
                </app-ticket-overview>
            </div>
        </ng-template>
    </app-wizard-step>
</app-wizard-modal>

<ng-template #infoMessage>
    <span class="info-message">{{ 'admin.tickets.create-modal.info.noMaintenancePlan' | translate }}</span>
</ng-template>

<app-revision-info-modal title="{{'admin.tickets.create-modal.revisionInfo.title' | translate}}">
</app-revision-info-modal>
